import React from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { getPostBySlug, blogPosts } from '../data/blogData';
import '../styles/BlogPost.css';

// Simple markdown renderer — handles #, ##, ###, >, **, paragraphs
const renderMarkdown = (text) => {
  const lines = text.split('\n');
  const elements = [];
  let key = 0;

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];

    if (line.startsWith('### ')) {
      elements.push(<h3 key={key++}>{line.slice(4)}</h3>);
    } else if (line.startsWith('## ')) {
      elements.push(<h2 key={key++}>{line.slice(3)}</h2>);
    } else if (line.startsWith('# ')) {
      elements.push(<h1 key={key++}>{line.slice(2)}</h1>);
    } else if (line.startsWith('> ')) {
      elements.push(<blockquote key={key++}>{line.slice(2)}</blockquote>);
    } else if (line.trim() === '') {
      elements.push(<br key={key++} />);
    } else {
      // Handle bold
      const parts = line.split(/\*\*(.*?)\*\*/g);
      const rendered = parts.map((part, idx) =>
        idx % 2 === 1 ? <strong key={idx}>{part}</strong> : part
      );
      elements.push(<p key={key++}>{rendered}</p>);
    }
  }

  return elements;
};

const BlogPost = () => {
  const { slug } = useParams();
  const post = getPostBySlug(slug);

  const related = blogPosts.filter(p =>
    p.slug !== slug && p.tags.some(t => post?.tags.includes(t))
  ).slice(0, 3);

  if (!post) {
    return (
      <>
        <Navbar />
        <div className="blogpost-page">
          <div className="blogpost-container">
            <p className="blogpost-notfound">Post not found.</p>
            <Link to="/blog" className="blogpost-back">← Back to Blog</Link>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />
      <div className="blogpost-page">
        <div className="blogpost-container">

          <Link to="/blog" className="blogpost-back">← Back to Blog</Link>

          <div className="blogpost-meta">
            <div className="blogpost-tags">
              {post.tags.map(tag => (
                <span key={tag} className="blogpost-tag">{tag}</span>
              ))}
            </div>
            <span className="blogpost-date">{post.date}</span>
          </div>

          <div className="blogpost-content">
            {renderMarkdown(post.content)}
          </div>

          {related.length > 0 && (
            <div className="blogpost-related">
              <h3 className="blogpost-related-title">Related Posts</h3>
              <div className="blogpost-related-list">
                {related.map(r => (
                  <Link to={`/blog/${r.slug}`} key={r.slug} className="blogpost-related-card">
                    <span className="blogpost-related-name">{r.title}</span>
                    <span className="blogpost-related-date">{r.date}</span>
                  </Link>
                ))}
              </div>
            </div>
          )}

        </div>
      </div>
      <Footer />
    </>
  );
};

export default BlogPost;